export default {
  ["SET_DATA_HOME"](state, { data }) {
    state.data = data;
  },
  ["SET_DATA_CATEGORY"](state, { data }) {
    state.dataCategory = data;
  },
  ["SET_DATA_INTREVIEW"](state, { data }) {
    state.dataIntreview = data;
  },
  ["SET_DATA_GUIDE"](state, { data }) {
    state.dataGuide = data;
  },
  ["SET_DATA_CATEGORY_TYPE"](state, { data }) {
    state.dataCategoryType = data;
  },
  ["SET_DATA_ABOUT"](state, { data }) {
    state.dataAbout = data;
  },
  ["SET_DATA_OBSERVATORY"](state, { data }) {
    state.dataObservatory = data;
  },
  ["SET_DATA_OBSERVATORY_ID"](state, { data }) {
    state.dataObservatoryId = data;
  },
  ["SET_DATA_REGULATION"](state, { data }) {
    state.dataRegulation = data;
  },
  ["SET_DATA_REGULATION_ID"](state, { data }) {
    state.dataRegulationId = data;
  },
  ["SET_DATA_NUMBERS"](state, { data }) {
    state.dataNumbers = data;
  },
  ["SET_DATA_NUMBERS_ID"](state, { data }) {
    state.dataNumbersId = data;
  },
  ["SET_DATA_EVENTS"](state, { data }) {
    state.dataEvents = data;
  },
  ["SET_DATA_EVENT_ID"](state, { data }) {
    state.dataEventId = data;
  },
  ["SET_DATA_RESOURCES"](state, { data }) {
    state.dataResources = data;
  },
  ["SET_DATA_RESOURCES_ID"](state, { data }) {
    state.dataResourcesId = data;
  },
  ["SET_DATA_LINKS"](state, { data }) {
    state.dataLinks = data;
  },
  ["SET_DATA_LINKS_ID"](state, { data }) {
    state.dataLinksId = data;
  },
};
